import PropTypes from 'prop-types';

export const ImageInterface = PropTypes.shape({
  x: PropTypes.string,
  y: PropTypes.string,
  postion: PropTypes.string,
  size: PropTypes.string,
  lines: PropTypes.bool
});
